import { Button, FormLabel, Input } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";

const CustomValues = () => {
    const { t } = useTranslation("translations");

    const [data, setData] = useState<any[]>([]);

    const changeValue = (value: string | number, index: number) => {
        const tmp = [...data];
        tmp[index].value = value;
        setData(tmp);
    }

    const fetch = async () => {
        try {
            const res = await getAxiosInstance().get("/GlobalVariables");
            setData(res.data);
        } catch (e) {
        }
    }

    const update = async (index: number) => {
        try {
            await getAxiosInstance().put("/GlobalVariables", {
                name: data[index].name,
                value: data[index].value + ""
            });
            toast.success(t("UPDATE_SUCCESSFULLY"), { position: "bottom-right"});
        } catch (e) {
            toast.error(t("UPDATE_FAILURE"), { position: "bottom-right"});
        }
    }

    useEffect(() => {
        fetch();
    }, [])

    return (
        <div className="flex flex-col">
            {
                data.map((e, index) => (
                    <div className="flex flex-col">
                        <FormLabel className="m-2">{t(e.name)}</FormLabel>
                        <div className="flex flex-row">
                            <Input
                                type="number"
                                inputMode="numeric"
                                className="mx-2"
                                value={e.value}
                                onChange={(e) => changeValue(+e.target.value, index)}
                            />
                            <Button
                                colorScheme="green"
                                onClick={() => update(index)}
                            >
                                {t("SAVE")}
                            </Button>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default CustomValues;